import { render, staticRenderFns } from "./AddCorporateOutstanding.vue?vue&type=template&id=6b0b66fd&"
import script from "./AddCorporateOutstanding.vue?vue&type=script&lang=js&"
export * from "./AddCorporateOutstanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports